import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'key-value' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
